module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG0d3155482386ab4c828b2e9d733ddd6b.0d315548.png";